<template>
  <ul class="pagination">
    <li class="pagination-item">
      <v-btn color="info" @click="onClickFirstPage" :disabled="isInFirstPage"
        >First</v-btn
      >
    </li>

    <li class="pagination-item">
      <v-btn color="info" @click="onClickPreviousPage" :disabled="isInFirstPage"
        >Previous</v-btn
      >
    </li>

    <li v-for="page in pages" class="pagination-item">
      <v-btn
        small
        fab
        color="primary"
        @click="onClickPage(page.name)"
        :disabled="page.isDisabled"
        :flat="isPageActive(page.name)"
      >
        {{ page.name }}
      </v-btn>
    </li>

    <li class="pagination-item">
      <v-btn @click="onClickNextPage" :disabled="isInLastPage" color="info"
        >Next</v-btn
      >
    </li>

    <li class="pagination-item">
      <v-btn @click="onClickLastPage" :disabled="isInLastPage" color="info"
        >Last</v-btn
      >
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3
    },
    totalPages: {
      type: Number,
      required: false,
      default: 10
    },
    total: {
      type: Number,
      required: false,
      default: 10
    },
    currentPage: {
      type: Number,
      required: false,
      default: 1
    }
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1
      }
      // When on the last page
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons
      }
      // When in between
      return this.currentPage - 1
    },
    pages() {
      const range = []
      for (
        let i = this.startPage;
        i <=
        Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        i += 1
      ) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        })
      }

      return range
    },
    isInFirstPage() {
      return this.currentPage === 1
    },
    isInLastPage() {
      return (
        this.totalPages === 0 ||
        (this.totalPages !== 0 && this.currentPage === this.totalPages)
      )
    }
  },
  watch: {
    totalPages(newValue, oldValue) {
      this.$app.log('New value is ' + newValue)
    }
  },
  methods: {
    isPageActive(page) {
      return this.currentPage === page
    },
    onClickFirstPage() {
      this.$emit('pagechanged', 1)
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1)
    },
    onClickPage(page) {
      this.$emit('pagechanged', page)
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1)
    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages)
    }
  }
}
</script>

<style>
.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.active {
  background-color: #4aae9b;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue